import { DELI_ENV_BASE_URL } from '@api/client';
import { Grid, Tooltip } from '@material-ui/core';
import { memo } from 'react';
import { TableInstance } from 'react-table';
import { qpSearchDataType } from './types';

function SentencesSubRow_({ row }) {
  const { person_data = {}, person_vtr_id = "" } = row;
  const { imdb_id = "", tmdb_id = "", hubspot_id = "", linkedin_url = "" } = person_data ?? {};
  return (
    <Grid container style={{ borderTop: '1px solid rgba(224, 224, 224, 1)', padding: "20px" }}>
      <Grid container item xs spacing={2}>
        {imdb_id && (
          <Tooltip title="IMDB">
            <a target="_blank" style={{ display: "flex" }} href={`https://www.imdb.com/name/${imdb_id}`}>
              <img style={{ height: "30px", width: "30px", marginRight: "20px", borderRadius: "4px", overflow: "hidden",   }} src="/images/imdb.png" />
            </a>
          </Tooltip>
        )}
        {tmdb_id && (
          <Tooltip title="TMDB">
            <a target="_blank" style={{ display: "flex" }} href={`https://www.themoviedb.org/person/${tmdb_id}`}>
              <img style={{ height: "30px", width: "30px", marginRight: "20px", borderRadius: "4px", overflow: "hidden",   }} src="/images/tmdb.jpeg" />
            </a>
          </Tooltip>
        )}
        {hubspot_id && (
          <Tooltip title="Hubspot">
            <a target="_blank" style={{ display: "flex" }} href={`https://app.hubspot.com/contacts/20258191/record/0-1/${hubspot_id}`}>
              <img style={{ height: "30px", width: "30px", marginRight: "20px", borderRadius: "4px", overflow: "hidden",   }} src="/images/HS_logo.jpeg" />
            </a>
          </Tooltip>
        )}
        {linkedin_url && (
          <Tooltip title="Linkedin">
            <a target="_blank" style={{ display: "flex" }} href={`${linkedin_url}`}>
              <img style={{ height: "30px", width: "30px", marginRight: "20px", borderRadius: "4px", overflow: "hidden",   }} src="/images/linkedin.png" />
            </a>
          </Tooltip>
        )}
        {person_vtr_id && (
          <Tooltip title="Person Master">
            <a target="_blank" style={{ display: "flex" }} href={`${DELI_ENV_BASE_URL}/person-management/edit/${person_vtr_id}`}>
              <img style={{ height: "30px", width: "30px", borderRadius: "4px", overflow: "hidden",   }} src="/images/vitrina.png" />
            </a>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
}

export const SentencesSubRow = ({
  row,
  instance: { setAllFilters },
}: {
  row: { original: qpSearchDataType };
  instance: TableInstance<qpSearchDataType>;
}) => {
  return <SentencesSubRow_ row={row.original} />;
};

export const SentencesSubRows = memo<any>(SentencesSubRow_, (prev, next) => {
  const eq = prev.row === next.row && prev.setAllFilters === next.setAllFilters;
  return eq;
});

